import {Component, EventEmitter, Input, OnChanges,OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import { format } from 'date-fns';
import {DigitalContractService} from 'src/app/core/services/digital-contract.service';
import {ReplaySubject, Subject} from 'rxjs';
import {DocumentTypeService} from '../../../../../../core/services/document-type.service';
import {CommonService} from '../../../../../../core/services/common.service';
import {ToastrService} from 'ngx-toastr';
import { takeUntil, tap } from 'rxjs/operators';
import { addDays } from 'date-fns';

@Component({
  selector: 'app-filter-contract-digitization',
  templateUrl: './filter-contract-digitization.component.html',
  styleUrls: ['./filter-contract-digitization.component.scss']
})

export class FilterContractDigitizationEmploymentComponent implements OnInit, OnChanges,OnDestroy {
  @Input() page = 0;

  @Input() pageSize = 10;

  @Input() sort: object;

  @Input() reload = true;

  @Input() featureStatus: boolean;

  @Output() data: EventEmitter<any> = new EventEmitter();

  isTableLoading = false;


  serviceTypes = [];

  checkFocus = false;
  trimInput: any;

  effectiveField = '';
  expiredField = '';

  isSearch = false;
  isInitForm = false;

  constructor(
    private fb: FormBuilder,
    public contractService: DigitalContractService,
    private documentTypeService: DocumentTypeService,
    public commonService: CommonService,
    private toast: ToastrService
  ) {
    if (!this.contractService.keepFilter.value) {
      this.contractService.filterContract.next(null);
      this.contractService.effectiveDateNewContract.next(null);
    }
  }

  filterForm: FormGroup;
  serviceTypeCtrl: FormControl = new FormControl();
  public filteredDocumentTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private onDestroySubject = new Subject<void>();

  isShow = false;

  ngOnChanges(changes: SimpleChanges): void {
    let isLoadData = false;
    if (this.featureStatus) {
      if (changes.page && !changes.page.firstChange) {
        isLoadData = true;
      } else if (changes.pageSize && !changes.pageSize.firstChange) {
        isLoadData = true;
      } else if (changes.sort && !changes.sort.firstChange) {
        isLoadData = true;
      } else if (changes.reload && !changes.reload.firstChange) {
        isLoadData = true;
        this.reload = false;
      }
    }
    if (isLoadData) {
      this.contractService.isSearch.next(true);
      if(!this.isInitForm) {
        this.getServiceTypes();
        this.initForm();
      }
      this.searchContract();
    }
  }

  ngOnInit() {
    this.getServiceTypes();
    this.initForm();
    if (this.featureStatus) {
      this.searchContract();
    }

    this.contractService.reloadFilter.subscribe(value => {
      if (value) {
        this.searchContract();
      }
    });
    this.serviceTypeCtrl.valueChanges
    .pipe(takeUntil(this.onDestroySubject))
    .subscribe(
      () => {
        this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypeCtrl, this.filteredServiceTypes);
      });

  }

  initForm() {
    let today = null;
    let lastDate = null;
    const now = new Date();
    const after90Days = addDays(now, 90);
    if (this.contractService.effectiveDateNewContract.value === null) {
      today = now.toISOString();
      lastDate = after90Days.toISOString();
    }

    this.filterForm = this.fb.group({
      docCode: new FormControl(null),
      docCodeParent: new FormControl(null),
      docParent: new FormControl(null),
      docType: new FormControl(null),
      effectiveFrom: new FormControl(null),
      effectiveTo: new FormControl(null),
      expireTimeFrom: new FormControl(null),
      expireTimeTo: new FormControl(null),
      sorts: new FormControl(null),
      nullExpiredDate: new FormControl(false),
      status: new FormControl(null),
      uuidContractMoha : new FormControl(null),
      mohaStatus : new FormControl(null),
      mohaConfirmStatus : new FormControl(null)
    });
    this.isInitForm = true;
    // if (this.contractService.effectiveDateNewContract.value !== null) {
    //   const date = this.contractService.effectiveDateNewContract.value;
    //   this.filterForm.controls.effectiveFrom.patchValue(date);
    //   this.filterForm.controls.effectiveTo.patchValue(date);
    // }
  }

  getServiceTypes() {
    this.documentTypeService.getServiceTypesMoha(localStorage.getItem('enterpriseId'), true).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      this.serviceTypes = rs.data;
      const filteredData = rs.data.filter(item => item.isEmploymentContract === true);
        this.filteredServiceTypes.next(filteredData);
    });
  }

  ngOnDestroy() {
    if (!this.contractService.keepFilter.value) {
      this.contractService.filterContract.next(null);
      this.contractService.isSearch.next(null);
    }
  }

  searchContract() {
    const control = this.filterForm.controls;
    let form;
    if ((this.contractService.effectiveDateNewContract.value
      || !this.contractService.filterContract.value
      || this.contractService.isSearch.value)
      && (!this.contractService.keepFilter.value || this.contractService.effectiveDateNewContract.value)
    ) {
      form = {
        contractNameOrCode: control.docCode.value,
        contractNameOrCodeParent:control.docCodeParent.value,
        contractParent: control.docParent.value,
        serviceType: control.docType.value,
        effectiveTimeFrom: control.effectiveFrom.value,
        effectiveTimeTo: control.effectiveTo.value,
        expireTimeFrom: control.expireTimeFrom.value,
        expireTimeTo: control.expireTimeTo.value,
        nullExpiredDate: control.nullExpiredDate.value,
        status: control.status.value,
        page: this.page,
        pageSize: this.pageSize,
        sorts: this.sort,
        uuidContractMoha : control.uuidContractMoha.value,
        mohaStatus : control.mohaStatus.value,
        mohaConfirmStatus : control.mohaConfirmStatus.value
      };
    } else {
      if (this.contractService.filterContract.value) {
        form = this.contractService.filterContract.value;
        this.filterForm.patchValue({
          docCode: form.contractNameOrCode || '',
          docCodeParent:form.contractNameOrCodeParent || '',
          docParent: form.contractParent || '',
          docType: form.serviceType,
          effectiveFrom: form.effectiveTimeFrom,
          effectiveTo: form.effectiveTimeTo,
          expireTimeFrom: form.expireTimeFrom,
          expireTimeTo: form.expireTimeTo,
          sorts: form.sorts,
          nullExpiredDate: form.nullExpiredDate,
          status: form.status,
          uuidContractMoha: form.uuidContractMoha,
          mohaStatus: form.mohaStatus,
          mohaConfirmStatus: form.mohaConfirmStatus
        });
      } else {
        form = {
          contractNameOrCode: control.docCode.value,
          contractNameOrCodeParent:control.docCodeParent.value,
          contractParent: control.docParent.value,
          serviceType: control.docType.value,
          effectiveTimeFrom: control.effectiveFrom.value,
          effectiveTimeTo: control.effectiveTo.value,
          expireTimeFrom: control.expireTimeFrom.value,
          expireTimeTo: control.expireTimeTo.value,
          nullExpiredDate: control.nullExpiredDate.value,
          status: control.status.value,
          page: this.page,
          pageSize: this.pageSize,
          sorts: this.sort,
          uuidContractMoha : control.uuidContractMoha.value,
          mohaStatus : control.mohaStatus.value,
          mohaConfirmStatus : control.mohaConfirmStatus.value
        };
      }
    }
    form.idMoha = form.uuidContractMoha;
    this.filterForm.controls.uuidContractMoha.patchValue(form.uuidContractMoha, { emitEvent: false });
    this.isTableLoading = true;
    this.data.emit(null); // bao list-contract xoa du lieu cu de hien skeleton
    this.contractService.getDigitalContractMoha(form).subscribe(res => {
        if (res.data && res.success) {
          this.isTableLoading = false;
          this.data.emit(res.data);
          this.contractService.filterContract.next(form);
          this.contractService.effectiveDateNewContract.next(null);
          this.contractService.keepFilter.next(null);
        } else {
          this.isTableLoading = false;
          this.toast.error(res.message);
        }
      },
      () => {
        this.isTableLoading = false;
      }
    );
  }

  focusOut(field: string) {
    if (this.filterForm.controls[field].errors &&
      this.filterForm.controls[field].errors.matDatepickerParse.text === ''
    ) {
      this.filterForm.controls[field].patchValue(null);
      this.filterForm.controls[field].setErrors(null);
    }
  }


  checkboxNull() {
    if (this.filterForm.controls.nullExpiredDate.value) {
      this.filterForm.controls.expireTimeFrom.reset();
      this.filterForm.controls.expireTimeTo.reset();
      this.filterForm.controls.expireTimeFrom.disable();
      this.filterForm.controls.expireTimeTo.disable();
    } else {
      this.filterForm.controls.expireTimeFrom.enable();
      this.filterForm.controls.expireTimeTo.enable();
    }
  }

  trimInputText(controlName: string): void {
    const control = this.filterForm.controls[controlName];
    if (control && control.value) {
      const trimmed = control.value.replace(/\s+/g, ' ').trim();
      if (control.value !== trimmed) {
        control.setValue(trimmed, { emitEvent: false });
      }
    }
  }
}


export class DigitalContract {
  id: string;
  name: string;
  code: string;
  contractParent: string;
  contractType: string;
  effectiveDate: Date;
  expireDate: Date;
  capacity: number;
  status: boolean;
  createdBy: string;
  checked: boolean
}
